<!--component html goes here -->
<label class="fontbold f2">Tags</label>
<div class="form-group addfile">
    <div class="input-group court" id="judge">
        <input type="file" name="file" id="file" class="file">
        <input type="text" name="file-name" placeholder="Type to add Matter Tag(s)" id="file-name"
            class="textbox form-control atype">
        <input *ngIf="!isEditing" type="button" class="btnfile savecls" value="ADD" (click)="addAdvicate()">
        <input *ngIf="isEditing" type="button" class="btnfile savecls" value="UPDATE" (click)="addAdvicate()">
    </div> 
    <button type="button" class="clear-btn" style="margin-left: auto;" *ngIf="isEditing" (click)="cancelEdit()">✕</button>
</div>

<div *ngIf="enableAdvicate">
    <form class="formAl" [formGroup]="memberDetail" (ngSubmit)="onSubmit()">
        <div class="form-group">
            <label for="title" class="fontbold">Tag
            </label>
            <!-- <input type="text" class="form-control textbox" (input)="restricttextSpace($event)" id="name" name="name"
                placeholder="Name" formControlName="name" [(ngModel)]="name"
                [ngClass]="{'is-invalid':submitted && f.name.errors}"> -->
            <input type="text" class="form-control textbox" id="name" name="name"
            placeholder="Name" formControlName="name" maxlength="100"
            [ngClass]="{'is-invalid': submitted && f.name.errors}">

            <div *ngIf="submitted && f['name'].errors" class="invalid-feedback">
                <div *ngIf="f['name'].errors['required']">Tag is required</div>
                <div *ngIf="f['name'].errors?.['alreadyExist']">Tag already exists</div>
            </div>
        </div>

        <div class="btnbox">
            <button type="button" class="btn btn-default btncancel btnrightitem" (click)="onCancel()">Cancel</button>
            <button type="submit" class="btn btn-default btnsave savecls infoBtn">Save</button>
        </div>


    </form>
</div>

<div class="flex-container" *ngIf="tags && tags.length>0">
    <div class="flexo" *ngFor="let item of tags;let i=index">
        <div class="opponent" [ngClass]="{'active':i === currentIndex}">
            <span class="name-ellipsis" [ngClass]="{'no-ellipsis': item.name?.length <= 12}">
                {{ item.name }}
            </span>
            <span>
                <i class="fa fa-edit" [ngClass]="{'disabled-icon': isEditing}" (click)="editOpponente(item,i)"></i>
                <i class="fa fa-regular fa-circle-xmark calimg input-group-append xgrp" [ngClass]="{'disabled-icon': isEditing}" (click)="removeOpponente(item)"></i>
            </span>
        </div>
    </div>
    
</div>